module.exports = __webpack_public_path__ + "img/total-hours-bar-chart.4ad2f6b6.png";